import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';
import type { GenericResponse } from '@/features/card/types/card.types';
import type { AddUserFormValues, ApproveUserFormValues, EditUserFormValues, UserDetails, InvitationAceptToken } from '@/features/team/types/team.types';


class TeamService {
	async getListMembers(page: number, limit: number): Promise<GenericResponse> {
		const newHeaders = buildCommonHeaders({
			withLocation: true
		});

		const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.team.listMembers, { data: { filter: { page_number: page, results_per_page: limit } } }, { headers: newHeaders });
		return response.data;
	}

	async createMember(values: AddUserFormValues): Promise<GenericResponse> {
		const newHeaders = buildCommonHeaders({
			withLocation: true
		});

		const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.team.createMember, { data: values }, { headers: newHeaders });
		return response.data.data;
	}


	async getMember(member_uuid: string): Promise<UserDetails> {
		const newHeaders = buildCommonHeaders({
			withLocation: true
		});

		const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.team.getMember, {}, { headers: newHeaders, params: member_uuid });
		return response.data.data;
	}

	async inviteAccept(values: InvitationAceptToken): Promise<GenericResponse> {
		const newHeaders = buildCommonHeaders({
			withLocation: true
		});

		const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.team.inviteAccept, { data: values }, { headers: newHeaders });
		return response.data.data;
	}

	async approveMember(values: ApproveUserFormValues, member_uuid: string): Promise<GenericResponse> {
		const newHeaders = buildCommonHeaders({
			withLocation: true
		});

		const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.team.approveMember, { data: values }, { headers: newHeaders, params: member_uuid });
		return response.data.data;
	}

	async updateMember(values: EditUserFormValues, member_uuid: string): Promise<GenericResponse> {
		const newHeaders = buildCommonHeaders({
			withLocation: true
		});

		const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.team.updateMember, { data: values }, { headers: newHeaders, params: member_uuid });
		return response.data.data;
	}

	async cancelMember(member_uuid: string): Promise<GenericResponse> {
		const newHeaders = buildCommonHeaders({
			withLocation: true
		});

		const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.team.cancelMember, {}, { headers: newHeaders, params: member_uuid });
		return response.data.data;
	}
}

export const teamService = new TeamService();
